import { MainLayout } from 'layouts/MainLayout'
import { NextPageWithLayout } from 'next'
import Script from 'next/script'

const TermsOfUse: NextPageWithLayout = () => {
  return (
    <>
      <div
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        name='termly-embed'
        data-id='a12fb71c-a824-4f97-9765-88c134eab7d1'
        datatype='iframe'
      />
      <Script id='termsOfUse' strategy='afterInteractive'>
        {`(function(d, s, id) {
              var js, tjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) return;
              js = d.createElement(s); js.id = id;
              js.src = "https://app.termly.io/embed-policy.min.js";
              tjs.parentNode.insertBefore(js, tjs);
            }(document, 'script', 'termly-jssdk'));`}
      </Script>
    </>
  )
}

TermsOfUse.getLayout = page => {
  return <MainLayout>{page}</MainLayout>
}

export default TermsOfUse
